import React from 'react';

const ErrorDisplay = ({ error, onRetry }) => {
  if (!error) return null;

  return (
    <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
      <div className="flex items-center">
        <div className="text-red-400 mr-2">⚠️</div>
        <div>
          <h3 className="text-sm font-medium text-red-800">Erreur de chargement</h3>
          <p className="text-sm text-red-700 mt-1">{error}</p>
        </div>
      </div>
      {onRetry && (
        <div className="mt-3">
          <button
            onClick={onRetry}
            className="px-3 py-1 bg-red-100 text-red-800 text-sm rounded hover:bg-red-200 transition-colors"
          >
            Réessayer
          </button>
        </div>
      )}
    </div>
  );
};

export default ErrorDisplay;